import { Text, Button, Center, Flex } from "@mantine/core";
import { modals } from "@mantine/modals";

import SRD_Form from "components/Form";
import React, { useState, useEffect } from "react";

import { useNavigate, useLocation } from "react-router-dom";
import { deleteGroup, getGroup, updateGroup } from "../apis/adminGroupApis";
import { getPathname } from "utils/getPathname";

function GroupEditForm() {
  const groupId = getPathname();
  const navigate = useNavigate();

  const [defaultValues, setDefaultValues] = useState();

  useEffect(() => {
    getGroup(groupId).then((res) => setDefaultValues(res));
  }, []);

  const location = useLocation();
  let backPage = 1;
  if (location.state) {
    backPage = location.state.pg;
  }

  const backToList = () => {
    const params = new URLSearchParams({page: String(backPage)});
    navigate(`/admin/group?${params.toString()}`, {replace: true});
  };

  const fields = [
    {
      key: "group_nm",
      name: "그룹명",
      type: "text",
    },
  ];

  const onSubmit = (e) => {
    modals.openConfirmModal({
      title: "수정",
      children: <Center>수정 하시겠습니까?</Center>,
   //   centered: true,
      zIndex: 2000,
      labels: { confirm: "수정", cancel: "취소" },
      onConfirm: () => {
        updateGroup(e);
        backToList();
      },
    });
  };

  const onDelete = () => {
    modals.openConfirmModal({
      title: "삭제",
    //  centered: true,
      zIndex: 2000,
      children: (
        <Center>
          <Text>정말 삭제하시겠습니까? (삭제 후 복구불가)</Text>
        </Center>
      ),
      labels: { confirm: "삭제", cancel: "취소" },
      confirmProps: { color: "red" },
      onConfirm: () => {
        deleteGroup(groupId)
        .then(res => alert(res));
        backToList();
      },
    });
  };

  const SubmitButton = () => {
    return (
      <Center style={{ marginTop: "1rem" }}>
        <Flex
          style={{
            width: "100%",
            justifyContent: "space-between",
            gap: "10px",
          }}
        >
          <Button color="red" onClick={() => onDelete()}>
            삭제
          </Button>
          <Button type="submit">수정</Button>
        </Flex>
      </Center>
    );
  };

  return (
    <SRD_Form
      fields={fields}
      onSubmit={onSubmit}
      submitButton={<SubmitButton />}
      defaultValues={defaultValues}
    />
  );
}

export default GroupEditForm;
